module.exports = __webpack_public_path__ + "8f4b93540ca2453fd1fadb3239f61aaa.svg";